import authHook from './auth.hook';
import fromHook from './from.hook';
import meHook from './me.hook';

export default router => {
    router.beforeEach(authHook);
    router.beforeEach(meHook);
    router.beforeEach(fromHook);
    return router;
};
